import _sfc_main from "./index.vue2.mjs";
/* empty css            */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "header" }, [_c("div", { staticClass: "header-container" }, [_c("div", { staticClass: "icon-box" }, [_c(_setup.SwitchCamera), _c(_setup.SwitchMirror), _setup.isWeChat ? _c(_setup.SwitchAudioRoute) : _vm._e()], 1), _c(_setup.RoomInfo, { staticClass: "room-info" }), _c(_setup.EndControl)], 1), _c(_setup.SwitchTheme, { attrs: { "visible": false } })], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "a8bd4f52"
);
const indexH5 = __component__.exports;
export {
  indexH5 as default
};
